import * as React from 'react';

import Dialog, { DialogProps } from './utils/DialogOverride';

import { iPhoneXQueries } from '@egr/xbox/egr-gui-elements/Helper/StyleHelper';
import { isTouchDevice } from '@egr/xbox/utils/UserAgent';
import { makeStyles, MakeStylesHook } from '@egr/xbox/utils/tss-react';

interface PositionFixedProps extends DialogProps {
    hasInput: boolean;
}

export const PositionFixedDialog: React.FC<PositionFixedProps> = React.memo(
    (props) => {
        const { classes } = usePositionFixedDialogStyle();

        const { hasInput, ...thisProps} = props;

        return (
            <Dialog {...thisProps} classes={(hasInput && isTouchDevice()) ? classes : undefined}/>
        );
    }
);

const usePositionFixedDialogStyle: MakeStylesHook<'scrollPaper'> = makeStyles({ name: 'PositionFixedDialog' })({
    scrollPaper: {
        '@media (max-width: 1400px)': {
            alignItems: 'flex-start',
            ...iPhoneXQueries({paddingTop: 30})
        }
    }
});